import axios from "./axios"

const url = "/module-categories"

const fetchErrorMsg = "Error fetching moldule categories:"
const createErrorMsg = "Error creating moldule category:"
const editErrorMsg = "Error updating moldule category:"
const destroyErrorMsg = "Error deleting moldule category:"

const ModuleCategoryApi = () => {
	const getAll = async () => {
		try {
			const response = await axios.get(url)
			return response.data
		} catch (error) {
			console.error(fetchErrorMsg, error)
			throw error
		}
	}

	const create = async (entity) => {
		try {
			const response = await axios.post(url, entity)

			return response.data
		} catch (error) {
			console.error(createErrorMsg, error)
			throw error
		}
	}

	const edit = async (id, entity) => {
		try {
			const response = await axios.put(`${url}/${id}`, entity)

			return response.data
		} catch (error) {
			console.error(editErrorMsg, error)
			throw error
		}
	}

	const destroy = async (id) => {
		try {
			const response = await axios.delete(`${url}/${id}`)

			return response.data
		} catch (error) {
			console.error(destroyErrorMsg, error)
			throw error
		}
	}

	return {
		getAll,
		create,
		edit,
		destroy,
	}
}

export default ModuleCategoryApi
